<template>
    <div>
        <el-table
            :data="settingData"
            style="width: 100%"
            empty-text="데이터가 없습니다."
        >
            <el-table-column
                label="포인트 지급 사유" width="" class-name="text-center" prop="pd_reason"
            >
                <template slot-scope="scope">
                    <div>
                        <el-input v-model="scope.row.pd_reason">
                        </el-input>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="지급 포인트" width="100" class-name="text-center" prop="pd_point"
            >
                <template slot-scope="scope">
                    <div>
                        <el-input v-model="scope.row.pd_point">
                        </el-input>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="1일 지급제한 (0 = 제한없음)" width="110" class-name="text-center" prop="pd_daily_limit"
            >
                <template slot-scope="scope">
                    <div>
                        <el-input v-model="scope.row.pd_daily_limit">
                        </el-input>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="조건" width="80" class-name="text-center" prop="pd_condition"
            >
                <template slot-scope="scope">
                    <el-input
                        v-if="scope.row.pd_is_condition === '1' "
                        v-model="scope.row.pd_condition"
                        type="number"
                    >
                    </el-input>
                    <span v-else-if="scope.row.pd_condition"></span>
                </template>
            </el-table-column>

            <el-table-column
                label="지급조건" width="" class-name="text-center" prop="pd_definition"
            >
                <template slot-scope="scope">
                    <span
                        v-html="scope.row.pd_condition > 0 ? `${scope.row.pd_definition} ${scope.row.pd_condition} 개 이상시` : `${scope.row.pd_definition}`">
                    </span>
                </template>
            </el-table-column>

            <el-table-column
                align="center"
                width="110"
                label="옵션"
                class-name="table_bottons"
            >
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="changeStatus(scope.row)"
                               v-if="scope.row.pd_is_use === 1">사용중
                    </el-button>
                    <el-button size="mini" type="danger" @click="changeStatus(scope.row)"
                               v-if="scope.row.pd_is_use === 0">사용안함
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "PointSettingComponent",
    mixins: [alertMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            settingData: [],
            originData: [],
            isRunning: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.getPointDefine()
        EventBus.$on('runSetting', this.runSetting);
    },
    beforeDestroy() {
        EventBus.$off('runSetting');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getPointDefine() {
            let params = {}
            try {
                this.$api.$point.getPointDefine(params).then(res => res.Data.Result).then(res => {
                    this.settingData = res.List
                    this.originData = JSON.parse(JSON.stringify(res.List))
                })
            } catch (e) {
                console.log(e);
            }
        },

        changeStatus(row) {
            return row.pd_is_use = row.pd_is_use === 1 ? 0 : 1;
        },

        _checkValidator() {
            let chk = 0
            this.settingData.forEach(v => {
                if (util.isEmpty(v.pd_reason) || util.isEmpty(v.pd_point) || util.isEmpty(v.pd_daily_limit) || util.isEmpty(v.pd_condition)) {
                    chk++
                }
            })
            if (chk > 0) {
                this.errorAlert('미입력 사항이 존재합니다.')
                this.isRunning = false;
                return false;
            }
            return true;
        },

        _makeParams(index = 0) {
            return {
                pd_code: this.settingData[index].pd_code,
                pd_reason: this.settingData[index].pd_reason,
                pd_point: this.settingData[index].pd_point,
                pd_daily_limit: this.settingData[index].pd_daily_limit,
                pd_condition: this.settingData[index].pd_daily_limit === 0 ? 0 : this.settingData[index].pd_condition,
                pd_is_use: this.settingData[index].pd_is_use,
            };
        },


        /*//재귀돌리는 함수 (index) {
        if (index에 대한 데이터 유무 ) {
                없으면 afterFunc
                this.isRunning = false;
                return false;
            }
        //     if(변경사항여부?) {
                    let params = this._makeParams();
                    api 통신
            }else {
                재귀 함수호출 (index+1)
            }
        // }*/

        recursionFunc(index) {
            if (util.isEmpty(this.settingData[index])) {
                this.afterFunc(true) ;
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
                return false;
            }

            // 값이 달라진게 있어야 돌아감
            if (!this.arraysEqual(this.settingData[index], this.originData[index])){
                let params = this._makeParams(index);
                EventBus.$emit('changeLoading', true);
                try {
                    this.$api.$point.updatePointDefine(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnUpdateType(res.Info.Type)
                        if (type === true) {
                            if (util.isEmpty(this.settingData[index + 1])) {
                                this.afterFunc(type);
                                this.isRunning = false;
                                EventBus.$emit('changeLoading', false);
                            }else{
                                this.recursionFunc(index + 1);
                            }
                        }
                    })
                } catch (e) {
                    console.log(e)
                    this.isRunning = false;
                    EventBus.$emit('changeLoading', false);
                }
            } else {
                this.recursionFunc(index + 1);
            }
        },

        arraysEqual(a1, a2) {
            return JSON.stringify(a1) === JSON.stringify(a2);
        },

        runSetting(index = 0) {
            if (this.isRunning) {
                return false;
            }

            this.isRunning = true;
            let validator = this._checkValidator();
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            this.recursionFunc(index);
        },

        returnUpdateType(type) {
            switch (type) {
                case 1 :
                    return true
                case 100 :
                    return '보내는 값이 잘못되었습니다.'
                default :
                    return '저장에 실패했습니다.'
            }
        },

        afterFunc(success) {
            let alertText = success ? '저장되었습니다.' : '저장에 실패하였습니다.';
            this.createAlert({
                title: "",
                content: alertText,
                btnText: "확인",
            })
            this.getPointDefine();
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
